import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"page-text"} maskId="square-filled-radius-0-stroke-1-IconPageText"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22H4V2ZM8 6V7H16V6H8ZM8 10V11H16V10H8ZM8 14V15H12V14H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPageText;
